import { Tooltip } from "react-bootstrap";
import styled from "styled-components";

// Estilizando o Tooltip com styled-components
export const CustomTooltip = styled(Tooltip)`
    --bs-tooltip-bg: rgb(74, 74, 74); /* Cor de fundo */
    --bs-tooltip-color: rgb(255, 255, 255); /* Cor de fundo */    
`;